import { find } from "../utils/dom"
export default function pageHome() {
	const Home = find('[js-page="home"]')
	if (!Home)
		return
	console.log(Home);

	const swiper = new Swiper(".mySwiper", {
		direction: "vertical",
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".custom-swiper-next",
			prevEl: ".custom-swiper-prev",
		},
	});

	const swiperHome = new Swiper(".swiperHome", {
		direction: "horizontal",
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
			el: ".swiper-pagination-home",
			clickable: true,
		}
	});

	const swiperNegocios = new Swiper(".swiper-negocios", {
		slidesPerView: "auto",
		spaceBetween: 32,
		direction: "horizontal",
		pagination: {
			el: ".swiper-pagination-negocios",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-negocios-next",
			prevEl: ".swiper-button-negocios-prev",
		},
	});

	const swiperBlogHome = new Swiper(".swiper-blog-home", {
		slidesPerView: "auto",
		spaceBetween: 32,
		direction: "horizontal",
		pagination: {
			el: ".swiper-pagination-blog-home",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-blog-home-next",
			prevEl: ".swiper-button-blog-home-prev",
		},
	});
}
